// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

// Component Files
import { FullPageDialogHeaderComponent } from './full-page-dialog-header.component';

@NgModule({
    declarations: [FullPageDialogHeaderComponent],
    exports: [FullPageDialogHeaderComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
    ]
})
export class FullPageDialogHeaderModule {}
